import Route from "vue-routisan";
import vuex from "@/vuex";
import isAuthenticated from "../middlewares/isAuthenticated";
import isBroker from "../middlewares/isBroker";
import hasIntegraPermission from "@/http/routes/middlewares/hasPermission/hasIntegraPermission";

Route.group({}, () => {
  Route.group({prefix: "logistic_manager",beforeEnter: [isAuthenticated, hasIntegraPermission]}, () => {

  Route.group({prefix: "broker", beforeEnter: [isBroker]}, () => {

      Route.redirect("/", to => {
        return {name: "broker.dashboard"};
      });

      Route.view("/dashboard", () =>
        import(/* webpackChunkName: "broker" */ "@/resources/views/logistic_manager/broker/Dashboard/Dashboard.vue")
      ).name("broker.dashboard");
    });
  });
});

export default Route.all();
